import { styled } from '@mui/material'

export const ModalTitleWrapper = styled('div')(({theme})=>({
    display:'flex',
    justifyContent:'flex-start',

    fontSize:'24px',
    fontWeight:600,
    marginBottom:'16px'
}))

export const ModalContentWrapper = styled('div')(({theme})=>({
    display:'flex',
    flexDirection:'column',
    gap:'16px',

}))

export const ModalLabelWrapper = styled('div')(({theme})=>({
    fontSize:'14px',
    color: '#808089',
}))

export const ModalInputBoxWrapper = styled('div')(({theme})=>({
    display:'flex',
    flexDirection:'column',
    gap:'10px',

}))

export const ModalFooterWarpper = styled('div')(({theme})=>({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',

}))